<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <router-link to="/" class="logo">
        <img src="/favicon/logo.png" alt="Half Panda" style="height: 40px;">
      </router-link>
    </div>
    <div class="navbar-actions">
      <div v-if="!currentUser">
        <button class="login-btn" @click="$emit('open-login')">登录</button>
      </div>
      <div v-else class="dropdown">
        <button class="dropbtn">{{ currentUser }}</button>
        <div class="dropdown-content">
          <router-link :to="{ name: 'UserCenter', params: { username: currentUser }}">用户信息</router-link>
          <a @click="handleLogout">登出</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  emits: ['open-login'],
  props: {
    currentUser: {
      type: String,
      default: null
    }
  },
  methods: {
    handleLogout() {
      this.$router.go(0);
      localStorage.clear();
      this.$emit('logout');
    },

  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%; /* 添加这一行 */
  box-sizing: border-box; /* 添加这一行 */
}

.logo {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
}

.login-btn {
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  background-color: #2ecc71; /* 添加背景颜色 */
  cursor: pointer;
  transition: all 0.3s ease; /* 添加过渡效果 */
}

.login-btn:hover {
  background-color: #27ae60; /* 悬停时改变背景颜色 */
  transform: translateY(-2px); /* 悬停时向上移动 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 悬停时添加阴影 */
}


.dropdown {
  position: relative;
  display: inline-block;
}

.dropbtn {
  background-color: #2980b9;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 120px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a,
.dropdown-content router-link {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover,
.dropdown-content router-link:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #1a6ea0;
}


</style>​